import {
  Component,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { AccountService } from '../../../../services/account.service';
import {
  IFunnel,
  IGroup,
  ICustomAttribute,
  ITag,
} from '../../../../interfaces/graph-types';

export interface ImportCandidatesFormOutputData {
  mapping: { source: string; destination: string }[];
  funnel?: IFunnel;
  group?: IGroup;
  updateCandidates?: boolean;
  monitorChanges?: boolean;
}

export interface MappingColumn {
  name: string;
  preview?: string;
}

export interface ImportCandidatesFormInputData {
  columns: MappingColumn[];
  total?: number;
}

@Component({
  selector: 'import-candidates-form',
  template: require('./import-candidates-form.component.pug'),
  styles: [require('./import-candidates-form.component.css').toString()],
})
export class ImportCandidatesFormComponent {
  @Input()
  data: ImportCandidatesFormInputData;
  @Input()
  sourceTitle: string;
  @Input()
  isSubmitting: boolean;
  @Input() fromDrive: boolean = false;

  @Output()
  onSubmit: EventEmitter<ImportCandidatesFormOutputData> = new EventEmitter();
  @Output()
  onCancel: EventEmitter<void> = new EventEmitter();

  email: any = null;
  firstName: any = null;
  lastName: any = null;
  company: any = null;
  title: any = null;
  role: any = null;
  phone: any = null;
  score: any = null;

  attributes$: Subscription = null;
  attributes?: ICustomAttribute[];
  attribute: ICustomAttribute = null;

  tags$: Subscription = null;
  tags?: ITag[];
  tag: ITag = null;

  funnels$: Subscription;
  funnels?: IFunnel[];
  funnel: IFunnel = null;

  groups$: Subscription;
  groups: IGroup[];
  group: IFunnel = null;

  updateCandidates = false;
  monitorChanges = false;

  autoImportLabel =
    "Important: Automatic imports will NEVER use the 'Update candidate if it exists' option when triggered. Spreadsheet is checked on an hourly basis for changes.";

  // -------------------------------------------------------------------
  constructor(
    private watch_account: WatchAccountService,
    private accountService: AccountService,
    private cd: ChangeDetectorRef,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.attributes$ = this.accountService
      .candidateAttributes(this.watch_account.accountId().getValue())
      .subscribe(data => {
        if (data) {
          this.attributes = [];
          data.forEach((attribute: ICustomAttribute) => {
            this.attributes.push(attribute);
          });
          this.checkAttributesMappging();
        }
      });

    this.tags$ = this.accountService
      .candidateTags(this.watch_account.accountId().getValue())
      .subscribe(data => {
        if (data) {
          this.tags = [];
          data.forEach((tag: ITag) => {
            this.tags.push(tag);
          });
          this.checkTagsMappging();
        }
      });

    this.funnels$ = this.accountService
      .funnelsNames(this.watch_account.accountId().getValue())
      .subscribe(funnels => {
        if (funnels) {
          this.funnels = funnels;
        }
      });

    this.groups$ = this.accountService
      .groups(this.watch_account.accountId().getValue())
      .subscribe(groups => {
        if (groups) {
          console.warn({ groups });
          this.groups = groups;
        }
      });

    this.data.columns.forEach((column: MappingColumn) => {
      if (column.name.toLowerCase().localeCompare('email') == 0) {
        this.email = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('first name') == 0) {
        this.firstName = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('firstname') == 0) {
        this.firstName = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('last name') == 0) {
        this.lastName = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('lastname') == 0) {
        this.lastName = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('company name') == 0) {
        this.company = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('company') == 0) {
        this.company = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('title') == 0) {
        this.title = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('role') == 0) {
        this.role = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('phone') == 0) {
        this.phone = column;
        return;
      }
      if (column.name.toLowerCase().localeCompare('score') == 0) {
        this.score = column;
        return;
      }
    });
  }

  // -------------------------------------------------------------------
  checkAttributesMappging() {
    if (this.attributes) {
      this.data.columns.forEach((column: MappingColumn) => {
        this.attributes.forEach((attribute: any) => {
          if (column.name.toLowerCase().localeCompare(attribute.name) == 0) {
            attribute.selection = column;
            return;
          }
        });
      });
    }
  }

  // -------------------------------------------------------------------
  checkTagsMappging() {
    if (this.tags) {
      this.data.columns.forEach((column: MappingColumn) => {
        this.tags.forEach((tag: any) => {
          if (column.name.toLowerCase().localeCompare(tag.name) == 0) {
            tag.selection = column;
            return;
          }
        });
      });
    }
  }

  // -------------------------------------------------------------------
  funnelChanged(funnel: IFunnel) {
    this.funnel = funnel;

    if (this.funnel) {
      this.group = null;
    }
  }

  // -------------------------------------------------------------------
  groupChanged(group: IGroup) {
    this.group = group;
  }

  // -------------------------------------------------------------------
  monitorChangesChanged(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.monitorChanges = !this.monitorChanges;
    if (this.monitorChanges) {
      this.updateCandidates = false;
    }
    onsuccess();
  }

  // -------------------------------------------------------------------
  updateCandidatesChanged(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.updateCandidates = !this.updateCandidates;
    if (this.updateCandidates) {
      this.monitorChanges = false;
    }
    onsuccess();
  }

  // -------------------------------------------------------------------
  refreshUI() {
    // also used by form after pusher initialised stage 5 :(
    this.cd.detectChanges();
  }

  // -------------------------------------------------------------------
  onSubmitClick() {
    let mapping = [];

    if (this.email) {
      let item = {};
      item['source'] = this.email.name;
      item['destination'] = 'email';
      mapping.push(item);
    }
    if (this.firstName) {
      let item = {};
      item['source'] = this.firstName.name;
      item['destination'] = 'first_name';
      mapping.push(item);
    }
    if (this.lastName) {
      let item = {};
      item['source'] = this.lastName.name;
      item['destination'] = 'last_name';
      mapping.push(item);
    }
    if (this.company) {
      let item = {};
      item['source'] = this.company.name;
      item['destination'] = 'company';
      mapping.push(item);
    }
    if (this.title) {
      let item = {};
      item['source'] = this.title.name;
      item['destination'] = 'title';
      mapping.push(item);
    }
    if (this.role) {
      let item = {};
      item['source'] = this.role.name;
      item['destination'] = 'role';
      mapping.push(item);
    }
    if (this.phone) {
      let item = {};
      item['source'] = this.phone.name;
      item['destination'] = 'phone';
      mapping.push(item);
    }
    if (this.score) {
      let item = {};
      item['source'] = this.score.name;
      item['destination'] = 'score';
      mapping.push(item);
    }

    if (this.attributes && this.attributes.length > 0) {
      this.attributes.forEach((attribute: any) => {
        if (attribute.selection) {
          let item = {};
          item['type'] = 'att';
          item['source'] = attribute.selection.name;
          item['destination'] = attribute.id;
          mapping.push(item);
        }
      });
    }

    if (this.tags && this.tags.length > 0) {
      this.tags.forEach((tag: any) => {
        if (tag.selection) {
          let item = {};
          item['type'] = 'tag';
          item['source'] = tag.selection.name;
          item['destination'] = tag.id;
          mapping.push(item);
        }
      });
    }

    this.onSubmit.emit({
      mapping,
      funnel: this.funnel,
      group: this.group,
      updateCandidates: this.updateCandidates,
      monitorChanges: this.monitorChanges,
    });
  }

  onCancelClick() {
    this.onCancel.emit();
  }
}
